import { Either } from "../../core/types/Either";
import { ContactInformation } from "../entity/ContactInformation";

export abstract class ContactInformationRepository {
  abstract getContactInformation(): Promise<Either<Error, ContactInformation>>;
}
